export default __webpack_public_path__ + "static/media/Apple-Pay-Color.f9b5f73d.svg";